var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJcb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 31,
    viewBox: "0 0 40 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.8667 24.5659C39.8667 27.9661 37.098 30.7348 33.6978 30.7348H0.133362V6.3022C0.133362 2.90203 2.90207 0.133331 6.30223 0.133331H39.8667V24.5659V24.5659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9376 18.2999H31.4877C31.5605 18.2999 31.7306 18.2756 31.8034 18.2756C32.2892 18.1785 32.702 17.7413 32.702 17.1342C32.702 16.5513 32.2892 16.1141 31.8034 15.9927C31.7306 15.9684 31.5848 15.9684 31.4877 15.9684H28.9376V18.2999Z",
    fill: "url(#paint0_linear_1_277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1963 2.19772C28.7676 2.19772 26.7761 4.16496 26.7761 6.61794V11.2082H33.0178C33.1635 11.2082 33.3335 11.2082 33.4549 11.2324C34.8636 11.3053 35.9079 12.0339 35.9079 13.2968C35.9079 14.2926 35.2036 15.1426 33.8921 15.3126V15.3612C35.325 15.4584 36.4179 16.2598 36.4179 17.4985C36.4179 18.8342 35.2036 19.7086 33.6007 19.7086H26.7518V28.6947H33.2364C35.6651 28.6947 37.6566 26.7275 37.6566 24.2745V2.19772H31.1963V2.19772Z",
    fill: "url(#paint1_linear_1_277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3863 13.5883C32.3863 13.0054 31.9734 12.6168 31.4877 12.5439C31.4391 12.5439 31.3177 12.5197 31.2448 12.5197H28.9376V14.6569H31.2448C31.3177 14.6569 31.4634 14.6569 31.4877 14.6326C31.9734 14.5598 32.3863 14.1712 32.3863 13.5883V13.5883Z",
    fill: "url(#paint2_linear_1_277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.76365 2.19772C4.33496 2.19772 2.34344 4.16496 2.34344 6.61794V17.5227C3.58207 18.1299 4.86928 18.5185 6.15648 18.5185C7.68655 18.5185 8.51231 17.5956 8.51231 16.3327V11.1839H12.3011V16.3084C12.3011 18.2999 11.0624 19.9271 6.8608 19.9271C4.31068 19.9271 2.31915 19.3685 2.31915 19.3685V28.6704H8.80375C11.2324 28.6704 13.224 26.7032 13.224 24.2502V2.19772H6.76365V2.19772Z",
    fill: "url(#paint3_linear_1_277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.98 2.19772C16.5513 2.19772 14.5598 4.16496 14.5598 6.61794V12.3982C15.6769 11.451 17.6199 10.8439 20.7529 10.9896C22.4287 11.0624 24.2259 11.5239 24.2259 11.5239V13.394C23.3273 12.9325 22.2587 12.5196 20.8743 12.4225C18.4942 12.2525 17.0613 13.4183 17.0613 15.4584C17.0613 17.5227 18.4942 18.6885 20.8743 18.4942C22.2587 18.3971 23.3273 17.9599 24.2259 17.5227V19.3928C24.2259 19.3928 22.453 19.8543 20.7529 19.9271C17.6199 20.0729 15.6769 19.4657 14.5598 18.5185V28.719H21.0443C23.473 28.719 25.4646 26.7518 25.4646 24.2988V2.19772H18.98V2.19772Z",
    fill: "url(#paint4_linear_1_277)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_277",
    x1: 26.772,
    y1: 17.137,
    x2: 37.6858,
    y2: 17.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_277",
    x1: 26.7717,
    y1: 15.4356,
    x2: 37.6864,
    y2: 15.4356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_277",
    x1: 26.7717,
    y1: 13.5852,
    x2: 37.686,
    y2: 13.5852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_277",
    x1: 2.3383,
    y1: 15.4356,
    x2: 13.4211,
    y2: 15.4356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8261,
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_277",
    x1: 14.497,
    y1: 15.4356,
    x2: 25.261,
    y2: 15.4356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1735,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5731,
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8585,
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60039"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 30.8681,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/jcb.136bee2a70358ee162e277d2e2210055.svg";
export { ForwardRef as ReactComponent };